import { useEffect } from 'react'
import { CapitalizeFirstLowercaseRest } from '../../../../Helpers/CustomConverter'
import { ConvertPriceToString } from '../../../../Helpers/CustomConverter'
import useGetProductPrices from '../../../../Components/BasketPage/Hooks/useGetProductPrices'
import { useConfig } from '../../../../Providers/ConfigProvider'
import { useParams } from '../../../../Providers/ParamsProvider'
import useGetProductImage from '../../../../Hooks/useGetProductImage'

import '../../../../Components/BasketPage/Styles/BasketPageStyles.css'

const ProductInSummary = ({ basketItem, isLastElement }) => {
    const { priceNetTotal, priceGrossTotal } = useGetProductPrices(basketItem.product, basketItem.qty)
    const { dataUrl } = useConfig()
    const { isMobile } = useParams()
    const { GetProductImage } = useGetProductImage()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    var holderStyle = isLastElement ? '' : 'newProduct-underline'

    if (isMobile) {
        return (<>
            <div className='row'>
                <div className="col-4">
                    <div className='newProduct-img p-2'>
                        <GetProductImage
                            photoFileName={basketItem.product.photoFileNames[0]}
                        />
                    </div>
                </div>
                <div className="col-8 d-flex flex-column">
                    <span>{CapitalizeFirstLowercaseRest(basketItem.product.title)}</span>
                    <span className='mt-2 light-text-color'>{CapitalizeFirstLowercaseRest(basketItem.product.label)}</span>
                </div>
            </div>
            <div className={`row mt-3 mb-4 pb-4 ${holderStyle}`}>
                <div className="col-4">
                    <div className='order-summary-products-count-mobile'>
                        <span>{`${basketItem.qty}`}</span>
                        <span className='ms-2'>{`${basketItem.product.baseUnit.toLowerCase()}`}</span>
                    </div>
                </div>
                <div className="col-8">
                    <b style={{ fontSize: '18px' }}>{ConvertPriceToString(priceNetTotal, basketItem.currency)}</b>
                    <div className='d-flex'>
                        <span>{ConvertPriceToString(priceGrossTotal, basketItem.currency)}</span>
                        <span className='ms-3 light-text-color'>{basketItem.product.taxRate + '%'}</span>
                    </div>
                </div>
            </div>
        </>)
    }
    else {
        return (
            <>
                <div className={`row mb-4 ${holderStyle}`}>
                    <div className="row">
                        <div className="col-2 align-items-center">
                            <div className='newProduct-img p-2'>
                                <GetProductImage
                                    photoFileName={basketItem.product.photoFileNames[0]}
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className='d-flex flex-column'>
                                <span>{CapitalizeFirstLowercaseRest(basketItem.product.title)}</span>
                                <span className='mt-2 light-text-color'>{CapitalizeFirstLowercaseRest(basketItem.product.label)}</span>
                            </div>
                        </div>
                        <div className="col-3 d-flex align-items-center">
                            <div className='order-summary-products-count'>
                                <span>{`${basketItem.qty}`}</span>
                                <span className='ms-2'>{`${basketItem.product.baseUnit.toLowerCase()}`}</span>
                            </div>
                        </div>
                        <div className="col-2 d-flex flex-column justify-content-center">
                            <b style={{ fontSize: '24px' }}>{ConvertPriceToString(priceNetTotal, basketItem.currency)}</b>
                            <div className='d-flex'>
                                <span>{ConvertPriceToString(priceGrossTotal, basketItem.currency)}</span>
                                <span className='ms-4 light-text-color'>{basketItem.product.taxRate + '%'}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default ProductInSummary